import React, { useState } from 'react'
import Card from '../Card'
import { Link, useNavigate } from 'react-router-dom'
import Moment from 'moment';
import * as DOMPurify from 'isomorphic-dompurify';


const PublicBlogCard = ({ elm }) => {
    const navigate = useNavigate();
    const hasBlogImage = Boolean(elm?.default_image?.file_name);
    const [imageSrc, setImageSrc] = useState(elm?.default_image?.file_name || '');
    const [isFallbackImage, setIsFallbackImage] = useState(!hasBlogImage);

    return (
        <>
            <div>
                <Card className="rounded  mb-0" >
                    <div className="event-images">
                        <Link to={`/dashboard/blog/publicBlogDetails/${elm?.slug}`}>
                            <div style={{ height: "186px", width: "100%", overflow: "hidden", background: "#f8fafc" }}>
                                {
                                    isFallbackImage ?
                                        <div
                                            style={{
                                                height: "100%",
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "10px",
                                                padding: "18px",
                                                background: "linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%)",
                                                borderBottom: "1px solid rgba(92, 81, 139, 0.08)"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "58px",
                                                    height: "58px",
                                                    borderRadius: "18px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "rgba(92, 81, 139, 0.1)",
                                                    color: "#5c518b"
                                                }}
                                            >
                                                <i className="material-symbols-outlined" style={{ fontSize: "30px" }}>article</i>
                                            </div>
                                            <div style={{ textAlign: "center" }}>
                                                <div style={{ fontSize: "15px", fontWeight: 600, color: "#2f2a4a", lineHeight: 1.3 }}>
                                                    News Update
                                                </div>
                                                <div style={{ fontSize: "13px", color: "#6b7280", marginTop: "4px" }}>
                                                    Thumbnail not available
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <img src={imageSrc}
                                            onError={() => {
                                                setImageSrc('')
                                                setIsFallbackImage(true)
                                            }}
                                            className="img-fluid" alt={elm?.title || 'Blog thumbnail'}
                                            style={{
                                                height: "100%",
                                                width: "100%",
                                                objectFit: "cover",
                                                display: "block"
                                            }} />
                                }
                            </div>
                        </Link>
                    </div>
                    <Card.Body>
                        <div style={{ margin: "-5px" }}>
                            <h5><Link to={`/dashboard/blog/publicBlogDetails/${elm?.slug}`} className="mb-2" >{elm?.title}</Link></h5>
                            {
                                elm?.body ?
                                    // <p >
                                    //     {(elm?.body).substring(1, 350)}
                                    //     {elm?.body?.length > 350 ? "....." : null}
                                    // </p> :
                                    <h6 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize((elm?.body).substring(0, 350) + (elm?.body?.length > 350 ? "..." : "")) }} />:
                                    null
                            }
                            <div className="blog-meta d-flex align-items-center mb-3 position-right-side">
                                <div className="date date me-2 d-flex align-items-center">
                                    <i className="material-symbols-outlined pe-0 md-18 text-primary" style={{ fontSize: "20px" }}>
                                        calendar_month
                                    </i>
                                    {Moment(elm?.created_at).format('MMM D YYYY')}
                                </div>
                                <div className="comments date me-2 d-flex align-items-center" style={{ cursor: "pointer" }}>
                                    <i className="material-symbols-outlined md-18 text-primary" style={{ fontSize: "20px" }}
                                        onClick={() => { navigate('/auth/sign-in') }} >thumb_up_alt</i>
                                    <div style={{ marginLeft: "1px" }}>
                                        {elm?.like_count + " "}like
                                    </div>
                                </div>
                                <div className="comments date me-2 d-flex align-items-center" style={{ cursor: "pointer" }}
                                    onClick={() => { navigate('/auth/sign-in') }}>
                                    <i className="material-symbols-outlined pe-1 md-18 text-primary" style={{ fontSize: "20px" }}>
                                        mode_comment
                                    </i>{elm?.comment_count} comments
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

            </div>

        </>
    )
}

export default PublicBlogCard
